import '../../css/mk-brand.css';
import {useEffect} from "react";
import SuperOgPanels from "../../constants/super-og-panels";

function Panel({onChangePanel, wallet}) {
    useEffect(() => {}, );
    const isConnected = wallet && wallet.connected;
    return (
        <div id="welcome-to-super-og" className="m-2">
            <div className="container bg-zinc-800 pt-4 px-4 md:px-32 pb-4 rounded-lg max-w-4xl">
                <div className="flex flex-row">
                    <div className="max-w-2xl mx-auto mb-10">
                        <div className="flex-row">
                            <div>
                                <div className="flex">
                                    <span className="text-5xl md:text-6xl lg:text-5xl font-bold text-brand">
                                      Super<span className="text-brand-text">OG </span>
                                    </span>
                                </div>
                                <div className="text-brand-text text-2xl text-right cursor-pointer hover:font-bold">
                                    <a href="https://metakitchen.gitbook.io/metakitchen-wp/wb1pN4vYLKsa8w4IX5qL/the-menu/game-mechanics/ready-set-whip">
                                        mini-game
                                    </a>
                                </div>
                                <div className="border border-brand" />
                            </div>
                        </div>
                        <div className="mt-6 text-white flex flex-col">
                            <div className="flex-row justify-center">
                                <div className="text-2xl pr-2">Welcome to the ultimate OG Chef challenge game.</div>
                                <div className="p-2" >
                                    <button
                                        disabled={!isConnected}
                                        className={`${isConnected ? 'bg-brand' : 'bg-zinc-500'} rounded-lg p-4 w-40 h-20 font-extrabold pull-right mr-4`}
                                        onClick={()=>{onChangePanel(SuperOgPanels.Lobby);}}
                                    >{isConnected ? 'Play Now' : 'Not Connected'}</button>
                                </div>
                            </div>
                            <p className="text-sx p-4">
                                An NFT mini-game where players
                                pit their OG Chefs against each other
                                in a real-time battle to win $CHEF coins.
                            </p>
                        </div>
                        <div className="text-xl px-4">
                            Here's how it works...
                        </div>
                        <div className="bg-zinc-400 p-8 rounded-lg flex-col space-y-2">
                            <p>Each player will need at least three OG Chefs, each of a different rarity, in their wallet. Each game consists of three rounds:</p>
                            <p className="mb-2"></p>
                            <table className="table-auto mx-auto">
                                <tbody className="">
                                    <tr>
                                        <td><div className="text-4xl rounded-full bg-brand p-4 fa fa-medal" /></td>
                                        <td><div className="text-2xl text-center">One-of-a-kind</div></td>
                                        <td><div className="p-2 bg-zinc-800 rounded-lg text-sm font-bold text-center">rarest OG Chef wins</div></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={3}>
                                            <div className="bg-brand h-1 w-full" />
                                        </td>
                                    </tr>
                                    <tr className="mx-auto">
                                        <td><div className="text-4xl rounded-full bg-brand p-4 fa fa-calendar-day" /></td>
                                        <td><div className="text-2xl text-center p-4">The OGist</div></td>
                                        <td><div className="p-2 bg-zinc-800 rounded-lg text-sm font-bold text-center">first mint date wins</div></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={3}>
                                            <div className="bg-brand h-1 w-full" />
                                        </td>
                                    </tr>
                                    <tr className="mx-auto text-center">
                                        <td><div className="text-5xl rounded-full bg-brand p-4 fa fa-person" /></td>
                                        <td><div className="text-2xl text-center">Trait vs. Trait</div></td>
                                        <td className="w-40"><div className="p-2 bg-zinc-800 rounded-lg font-bold text-sm">rarest random trait wins</div></td>
                                    </tr>
                                </tbody>
                            </table>
                            <p>The order of the rounds is randomly determined by the <span className="text-brand font-extrabold">Super</span><span className="font-extrabold">OG</span> game server when the game is run.</p>
                            <div className="border border-brand" />
                            <p><b>Player 1 </b>approves a wager amount in $CHEF (including gas fees), as well as, three OG Chefs from their wallet to use in the game, and then presses <button className="bg-brand px-4 py-2 font-bold rounded-lg mt-1">Challenge</button></p>
                            <div className=""> Now other players can view and accept the challenge.</div>
                            <div className="border border-brand" />
                            <p><b>Player 2</b> browses the list of challenges, accepts one, and approves a Phantom wallet transaction for the challengers wager amount in $CHEF (including gas fees). To accept the challenge, Player 2 chooses three OG Chefs from their wallet to use in the game, and then presses <button className="bg-brand px-4 py-2 font-bold rounded-lg">Approve</button></p>
                            <div className="border border-brand" />
                            <p>When <b>Player 2</b> presses play the <span className="text-brand font-extrabold">Super</span><span className="font-extrabold">OG</span> game server program executes, a winner is determined, the winner then receives an SPL token transfer with the game payout in $CHEF. Both players can view the animated results of the game. The transaction, once completed, is available for verification and inspection on the Solana Blockchain.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Panel;